import * as React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { AuthProvider, UserProvider } from '@pletly/feature-auth';
import { AppUpdateInfoProvider } from '@pletly/feature-check-updates';
import { BreakpointsProvider } from 'rn-responsive-styles';

import { Toast, toastConfig, ModalProvider } from '@pletly/ui';
import { LoadingOverlayProvider } from '%context';
import { ThemeProvider } from '%theme';
import { usePushToken } from '%services/notifications';
import { AnalyticsProvider } from '%services/analytics';
import { BREAKPOINTS } from '%constants/breakpoints';
import { ClientApp } from '%__generated__/types';

export function AppProviders({ children }: React.PropsWithChildren) {
	const { savePushToken, clearPushToken } = usePushToken();

	return (
		<AnalyticsProvider>
			<AuthProvider onLogin={savePushToken} beforeLogOut={clearPushToken}>
				<BreakpointsProvider breakpoints={BREAKPOINTS}>
					<ThemeProvider>
						<LoadingOverlayProvider>
							<ModalProvider>
								<SafeAreaProvider>
									<AppUpdateInfoProvider app={ClientApp.Pal}>
										<StatusBar />
										<UserProvider>{children}</UserProvider>
										<Toast config={toastConfig} />
									</AppUpdateInfoProvider>
								</SafeAreaProvider>
							</ModalProvider>
						</LoadingOverlayProvider>
					</ThemeProvider>
				</BreakpointsProvider>
			</AuthProvider>
		</AnalyticsProvider>
	);
}
